import axios from "axios";
import configuration from "@/utils/configuration";

const registerModules = {
  namespaced: true,
  state: {
    user: null,
    isRegistered: false,
    errorMessage: null,
    isLoading: false,
  },
  getters: {
    isRegistered: (state) => state.isRegistered,
    getRegisteredUser: (state) => state.user,
    getErrorMessage: (state) => state.errorMessage,
    isLoading: (state) => state.isLoading,
  },
  mutations: {
    setRegisteredUser(state, { user }) {
      state.user = user;
      state.isRegistered = true;
      state.errorMessage = null;
      state.isLoading = false;
    },
    clearRegisteredUser(state) {
      state.user = null;
      state.isRegistered = false;
      state.errorMessage = null;
      state.isLoading = false;
    },
    setErrorMessage(state, message) {
      state.errorMessage = message;
      state.isLoading = false;
    },
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
  },
  actions: {
    async registerUser({ commit }, payload) {
      commit("setLoading", true);
      try {
        const response = await axios.post(
          `${configuration.authUrl}/registerOneID`,
          payload
        );
        const { data } = response;

        if (data.statusCode === 201) {
          commit("setRegisteredUser", { user: data});
          return data;
        } else {
          const errorMsg = `Unexpected status code: ${data.statusCode}`;
          commit("setErrorMessage", errorMsg);
          throw new Error(errorMsg);
        }
      } catch (error) {

        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          const errorMessageObj = error.response.data.message;
          commit("setErrorMessage", errorMessageObj);
          return Promise.reject(errorMessageObj); 
        }
      } finally {
        commit("setLoading", false);
      }
    },
    clearUserRegistration({ commit }) {
      commit("clearRegisteredUser");
    },
  },
};

export default registerModules;
